import { Link } from "react-router-dom";
import logo from "../assets/matou-bird-logo.png";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">
      <img src={logo} alt="Mātou" className="h-20 w-auto mb-8" />
      <h1 className="text-5xl md:text-6xl font-semibold text-gray-100">404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold mt-6">
        We can't find that page
      </h2>
      <p className="mt-4 text-xl md:text-2xl text-gray-500">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link
        to="/"
        className="mt-8 inline-block rounded-lg px-6 py-3 text-lg font-medium bg-gray-100 text-gray-900 hover:bg-white transition"
      >
        Back to home
      </Link>
    </div>
  );
}
